module.exports = __webpack_public_path__ + "static/media/ava.ae96ed19.svg";